import {csrf} from "~/lib/tools";

const createTask = async (org_id, payload) => {
    return await fetch(
        `/dashboard/organizations/${org_id}/tasks.json`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                "X-CSRF-Token": csrf()
            },
            body: JSON.stringify(payload),
        })
        .then(async r => {
            let json = await r.json();
            return {
                ok: r.ok,
                status: r.status,
                data: json.data,
                error: r.statusText,
                errors: json.errors
            }
        });
}

const updateTask = async (org_id, task_id, payload) => {
    return await fetch(
        `/dashboard/organizations/${org_id}/tasks/${task_id}.json`,
        {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                "X-CSRF-Token": csrf()
            },
            body: JSON.stringify(payload),
        })
        .then(async r => {
            let json = await r.json();
            return {
                ok: r.ok,
                status: r.status,
                data: json.data,
                error: r.statusText,
                errors: json.errors
            }
        });
}



const updateTaskStatus = async (org_id, work_order_id, status) => {
    return await fetch(
        `/dashboard/organizations/${org_id}/tasks/${work_order_id}/update_status`,
        {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                "X-CSRF-Token": csrf()

            },
            body: JSON.stringify({status: status})
        })
        .then(async r => {
            return await r.json()
        });
}
export {createTask, updateTaskStatus, updateTask}